<template>
    <div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{ $t("message.summary") }}</span>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
                <span class="time">{{$t('message.lastUpdate')}}: {{currentUser.updatedAt | timeFormat}}</span>
            </vs-col>
        </vs-row>
        <div class="user-info mt-4">
            <h5>{{ $t("lang.hi") }} {{ currentUser.name }}</h5>
            <h5>{{ $t("lang.welcome") }}：{{ customer.accountId }}</h5>
            <h5>{{ $t("lang.summary_total_amount") }}：{{ $t('lang.usd') }} {{ totalAmount.toLocaleString() }}</h5>
        </div>
        <vs-row class="chart-area">
            <vs-col vs-w="6">
                <div class="chart">
                 <highcharts :options="chartOptions"></highcharts>
                 <div class="chart-options">
                    <ul>
                        <li>{{ $t("lang.credit_card") }} {{calculatePercentage.cardPercentage ? `${Math.round(calculatePercentage.cardPercentage)}%` : "N/A" }}</li>
                        <li>{{ $t("lang.cash") }} {{ calculatePercentage.cashPercentage ? `${Math.round(calculatePercentage.cashPercentage)}%` : "N/A" }}</li>
                        <li>{{ $t("lang.fixed_return") }} {{ calculatePercentage.returnPercentage ? `${Math.round(calculatePercentage.returnPercentage)}%` : "N/A" }}</li>
                    </ul>
                 </div>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="flex justify-center items-center h-full">
                    <div class="chart-details">
                    <ul>
                        <li>
                            <div class="flex justify-between">
                                <div class="details-left">{{ $t("lang.credit_card") }}</div>
                                <div class="details-right"><span>{{ summary.creditCard.toLocaleString() }}</span><span></span></div>
                            </div>
                        </li>
                        <li>
                            <div class="flex justify-between">
                                <div class="details-left">{{ $t("lang.cash") }}</div>
                                <div class="details-right">{{ (summary.fixedCustody + summary.currentCustody).toLocaleString() }}<span></span><span><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m16.843 10.211c.108-.141.157-.3.157-.456 0-.389-.306-.755-.749-.755h-8.501c-.445 0-.75.367-.75.755 0 .157.05.316.159.457 1.203 1.554 3.252 4.199 4.258 5.498.142.184.36.29.592.29.23 0 .449-.107.591-.291 1.002-1.299 3.044-3.945 4.243-5.498z"/></svg></span></div>
                            </div>
                            <ul class="chart-details-sub">
                                <li class="flex justify-between mt-3">
                                    <div>{{ $t("lang.fixed_custody") }}</div>
                                    <div>{{ summary.fixedCustody.toLocaleString() }}</div>
                                </li>
                                <li class="flex justify-between mt-3">
                                    <div>{{ $t("lang.current_custody") }}</div>
                                    <div>{{ summary.currentCustody.toLocaleString() }}</div>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <div class="flex justify-between">
                                <div class="details-left">{{ $t("lang.fixed_return") }}</div>
                                <div class="details-right"><span>{{ summary.fixedReturn.toLocaleString() }}</span><span></span></div>
                            </div>
                        </li>
                    </ul>
                </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import $cookies from "vue-cookies";
    import {Chart} from 'highcharts-vue'


    export default {
        components: {
            highcharts:Chart
        },
        beforeRouteEnter(to, from, next){
            if($cookies.get('role') == 'user'){
                next()
            }else if($cookies.get('role') == 'agent'){
                next('/customer')
            }else if($cookies.get('role') == 'admin'|| $cookies.get('role') == 'manager'){
                next('/account_staff')
            }
        },
        data() {
            return {
                summary: {
                    creditCard: 0, 
                    demandDepositTrustAmount: 0, 
                    fixedReturn: 0, 
                    timeDepositTrustAmount: 0
                },
                customer: {},
                chartOptions:{
                    chart: {
                        type: 'pie',
                        options3d: {
                            enabled: true,
                            alpha: 70,
                            beta: 0
                        },
                        
                        width: 250,
                        height: 250,
                        marginLeft: 0,
                        marginRight: 0,
                        spacing:[0,0,0,0]
                    },
                    accessibility: {
                        point: {
                        }
                    },
                    credits:{
                        enabled:false
                    },
                    legend: {
                        itemMarginTop:10,
                        itemMarginBottom:10,
                        padding:0,
                        labelFormatter: function () {
                            return 'Hello';
                        }
                    },
                    title:{
                        text:null
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            depth: 50,
                            dataLabels: {
                                enabled: false,
                                padding:0,
                                softConnector: false,
                                connectorPadding:10,
                                distance:50,
                                format: '<span style="color:{point.color};font-size:14px">{point.name}</span><br>' +
                                    '<span style="color: #bdbcbc;">{point.other.totalNetContributionSinceEffectiveDate}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.totalTransferAsset}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.totalTransferOutAsset}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.investmentBalanceSinceEffectiveDate}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.balance}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.return}</span>'
                            }
                        }
                    },
                    colors:['#EEAC2D', '#497C06', '#5D73A8'],
                    tooltip: {
                        enabled: false,
                        pointFormat: '<b>{point.x}</b> <b>{point.y:,.0f}</b>'

                    },
                    series: [{
                        type: 'pie',
                        data: [
                        {
                            y: 0,
                        },
                        {
                            y: 0
                        },
                        {
                            y: 0
                        }
                        ],
                        showInLegend: false
                    }]
                }
            }
        },
        
        computed:{
            ...mapGetters(["currentUser"]),
            totalAmount: function () {
                const {creditCard, currentCustody, fixedReturn, fixedCustody} = this.summary;
                return creditCard + currentCustody + fixedReturn + fixedCustody;
            },

            calculatePercentage: function(){
                const {creditCard, currentCustody, fixedReturn, fixedCustody} = this.summary;
                const cash = currentCustody + fixedCustody;

                let total = this.totalAmount;

                let cardPercentage = (creditCard / total) * 100;
                let cashPercentage = (cash / total) * 100;
                let returnPercentage = (fixedReturn / total) * 100;
                return {cardPercentage, cashPercentage, returnPercentage};
            }
        },
        created() {
            let url = process.env.VUE_APP_API_BASEURL + '/api/me?access_token=' + this.$cookies.get('token');
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
                this.customer = data.responseDetail.customer;
                if(data.responseDetail.customer.summary){
                    this.summary = data.responseDetail.customer.summary;
                    this.updateChart();
                }
            })
        },
        methods: {
            updateChart() {
                this.chartOptions.series[0].data = [
                    {
                        y: this.calculatePercentage.cardPercentage,
                    },
                    {
                        y: this.calculatePercentage.cashPercentage,
                    },
                    {
                        y: this.calculatePercentage.returnPercentage,
                    }
                ];
            }
        },
    }
</script>

<style scoped>
    .highcharts-pie-series .highcharts-point {
        stroke-width: 2px;
    }
    .highcharts-pie-series .highcharts-data-label-connector {
        stroke-width: 2px;
    }
    .chart{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #000;
    }
    .chart-options>ul>li{
        position: relative;
        margin-bottom: 10px;
    }
    .chart-options>ul>li::before, .chart-details>ul>li::before{
        content: "";
        width: 12px;
        height: 12px;
        display: inline-block;
        position: absolute;
        left: -20px;
        top: 5px;
    }
    .chart-options>ul>li:nth-child(1)::before, .chart-details>ul>li:nth-child(1)::before{
        background-color: #EEAC2D;
    }
    .chart-options>ul>li:nth-child(2)::before, .chart-details>ul>li:nth-child(2)::before{
        background-color: #497C06;
    }
    .chart-options>ul>li:nth-child(3)::before, .chart-details>ul>li:nth-child(3)::before{
        background-color: #5D73A8;
    }
    .chart-details{
        width: 360px;
        height: 100%;
        display: flex;
        align-items: center;
    }
    .chart-details>ul{
        width: 100%;
    }
    .chart-details>ul>li{
        position: relative;
        margin-bottom: 15px;
        font-weight: 600;
    }

    .chart-details>ul>li .details-right{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .chart-details>ul>li .details-right>span:nth-child(2){
        width: 18px;
        margin-top: -2px;
    }
    .chart-details>ul>li .details-right>span:nth-child(2)>svg{
        fill: #231815;
    }
    .chart-details-sub li{
        border-bottom: 1px solid #808080;
        font-weight: normal;
    }
    .user-info{
        margin-bottom: 80px;
        padding: 0 15px;
    }

    @media (max-width: 768px) {
    .chart-area{
        flex-direction: column;
        align-items: center;
    }
    .chart{
        border-right: none;
    }
    .vs-col{
        margin-bottom: 10px;
    }
    .chart-details{
        width: 100%;
    }
}

</style>
